import '@progress/kendo-theme-default/dist/all.css';
import * as React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import reportWebVitals from 'reportWebVitals';
import 'styles/root.less';
import 'swiper/css';
import './locales/i18n';
import { msalInstance } from './msalConfig/msalConfig';
import { AppInitializer } from 'app/components/app';
import { ServiceProviders } from 'app/components/ReactContexts';

ReactGA.initialize([
  {
    trackingId: process.env.GA_TRACKING_CODE || '',
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

msalInstance.initialize().then(() => {
  root.render(
    <>
      {/* <React.StrictMode> */}
      <ServiceProviders>
        <AppInitializer />
      </ServiceProviders>
      {/* </React.StrictMode> */}
    </>,
  );
});

// Hot reloadable translation json files
if (module.hot) {
  module.hot.accept(['./locales/i18n'], () => {
    // No need to render the App again because i18next works with the hooks
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
